module.exports = __webpack_public_path__ + "static/img/item-l_j_peach.0567e91.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/item-l_j_peach.png
// module id = zPjF
// module chunks = 1